// extracted by mini-css-extract-plugin
module.exports = {"subtitleWrap":"PricingSubtitle_subtitleWrap__DQLm6","subtitle":"PricingSubtitle_subtitle__3tpd9","dotted":"PricingSubtitle_dotted__3xVg0"};